import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-templates-delete',
    templateUrl: './templates-delete.component.html',
    styleUrls: ['./templates-delete.component.scss']
})
export class TemplatesDeleteComponent {
    name: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.name = this.data.dataKey;
    }
}
